const ResponsablesRetraso = [
  {label: "Por definir", value: "Por definir"},
  {label: "Cliente", value: "Cliente"},
  {label: "Agencia", value: "Agencia"},
  {label: "No aplica", value: "No aplica"},
]

export default ResponsablesRetraso;